// extracted by mini-css-extract-plugin
export default {"pageWrap":"Bd-z","fullWidth":"Cd-z","heading":"Dd-z","fullBleed":"Ed-z","hidden":"Fd-z"};